import React from "react";
import { Backdrop, CircularProgress, useTheme } from "@mui/material";

export default function ModalLoadingFull(props) {
  const { sx } = props;

  const theme = useTheme();

  return (
    <Backdrop
      sx={{
        zIndex: 99999,
        color: theme?.palette?.primary?.main,
        ...sx,
      }}
      open={true}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}
